import React from 'react';
import styled from 'styled-components';

export const ChartContainer = styled.div`
  position: relative;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
`;

export const ChartWatermark = styled.img`
  position: absolute;
  pointer-events: none;
  user-select: none;
`;

export const Chart = styled.svg`
  cursor: grab;
`;

export const ChartFocus = styled.g``;

export const XAxisLabel = styled(({ bold, ...props }) => <text {...props} />)`
  font-size: 13px;
  line-height: 16px;
  stroke-width: 0;
  fill: #474747;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;

export const YAxisLabel = styled.text`
  font-size: 12px;
  line-height: 14px;
  font-weight: bold;
  stroke-width: 0;
  fill: #5b6575;
`;

export const AxisLine = styled.line`
  stroke: #cad4e6;
  stroke-width: 1px;
`;

export const Empty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => `${height || 364}px`};
  color: #93a1a9;
`;
